import { configureStore } from "@reduxjs/toolkit";
import alertSlice from "./alertSlice";
import modeSlice from "./modeSlice";
import loginSlice from "./loginSlice";
import loaderSlice from "./loaderSlice";
import shippingSlice from "./shippingSlice";
// import summarySlice from "./summarySlice";
import footerSlice from "./footerSlice";
import userSlice from "./userSlice";
import shopsSlice from "./shopsSlice";
import citiesSlice from "./citiesSlice";
import streetsSlice from "./streetsSlice";
import basketSlice from "./basket";
import personalDetails from "./personalDetailsSlice";
import guardSlice from "./guardSlice";
import errorSlice from "./errorSlice";
import couponsSlice from "./couponsSlice";
import modalSlice from "./modalSlice";
import successSlice from "./successSlice";
import creditGuardSlice from "./creditGuardSlice";
import licenseSlice from "./licenseSlice";

const store = configureStore({
    reducer: {
        mode: modeSlice.reducer,
        alert: alertSlice.reducer,
        login: loginSlice.reducer,
        loader: loaderSlice.reducer,
        shipping: shippingSlice.reducer,
        footer: footerSlice.reducer,
        user: userSlice.reducer,
        shops: shopsSlice.reducer,
        cities: citiesSlice.reducer,
        streets: streetsSlice.reducer,
        basket: basketSlice.reducer,
        personalDetails: personalDetails.reducer,
        guard: guardSlice.reducer,
        error: errorSlice.reducer,
        coupons: couponsSlice.reducer,
        modal: modalSlice.reducer,
        success: successSlice.reducer,
        creditGuard: creditGuardSlice.reducer,
        license: licenseSlice.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;
